const textStyles = {
    webH1: {
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    webH2: {
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    webH3: {
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    webH4: {
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    cta: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    ctaUnderlined: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    ctaOther: {
        fontSize: '16px',
        textTransform: 'capitalize'
    },
    largeTitle1: {
        textTransform: 'capitalize'
    },
    largeTitle2: {
        textTransform: 'capitalize'
    },
    badge: {
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    labelXs: {
        lineHeight: {base: '18px', md: '20px', lg: '20px'},
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    labelSm: {
        textTransform: 'capitalize'
    },
    labelSmMd: {
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    labelMdSm: {
        textTransform: 'capitalize'
    },
    subtitle: {
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    footer: {
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    webButtonTypography: {
        fontSize: {base: 'webLg'},
        lineHeight: {base: '20px'},
        fontWeight: 'normal',
        textTransform: 'none'
    },
    bodySmBold: {
        fontWeight: 'normal'
    }
}

export {textStyles}
